export default {
    urls: {
        VUE_APP_DEV_BACKEND_BASE_URL:"https://dev.icpaunion.com/api/",
        VUE_APP_DEV_FRONTEND_BASE_URL:"https://dev.icpaunion.com/",

        VUE_APP_PROD_BACKEND_BASE_URL:"https://icpaunion.com/api/",
        VUE_APP_PROD_FRONTEND_BASE_URL:"https://icpaunion.com/",
    }
}